export interface ISaveSystemReviewResponse {
  systemReviewId: number;
}

export class SaveSystemReviewResponse implements ISaveSystemReviewResponse {
  systemReviewId: number;
}
